import { render, staticRenderFns } from "./ValuesCard.vue?vue&type=template&id=0d22870e&scoped=true&"
import script from "./ValuesCard.vue?vue&type=script&lang=js&"
export * from "./ValuesCard.vue?vue&type=script&lang=js&"
import style0 from "./ValuesCard.vue?vue&type=style&index=0&id=0d22870e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22870e",
  null
  
)

export default component.exports